'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/shad';
import * as React from 'react';
interface CircularProgressProps {
  value: number; // 0–100
  renderLabel?: (progress: number) => number | string;
  size?: number;
  circleStrokeWidth?: number;
  progressStrokeWidth?: number;
  shape?: 'square' | 'round';
  className?: string;
  progressClassName?: string;
  labelClassName?: string;
  showLabel?: boolean;
  error?: boolean;
  warning?: boolean;
}
export const CircularProgress = t0 => {
  const $ = _c(48);
  const {
    value,
    className,
    progressClassName,
    labelClassName,
    shape: t1,
    size: t2,
    circleStrokeWidth,
    progressStrokeWidth,
    error,
    warning
  } = t0;
  const shape = t1 === undefined ? "round" : t1;
  const size = t2 === undefined ? 24 : t2;
  const effectiveCircleStrokeWidth = circleStrokeWidth ?? size * 0.1;
  const effectiveProgressStrokeWidth = progressStrokeWidth ?? size * 0.1;
  const radius = Math.max(size / 2 - Math.max(effectiveCircleStrokeWidth, effectiveProgressStrokeWidth), 1);
  const circumference = 2 * Math.PI * radius;
  const isTerminal = error || warning;
  const clampedValue = isTerminal ? 100 : Math.min(100, Math.max(0, value));
  const strokeDashoffset = circumference * ((100 - clampedValue) / 100);
  const isComplete = clampedValue === 100 && !error && !warning;
  let t3;
  if ($[0] !== size) {
    t3 = {
      width: size,
      height: size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `0 0 ${size} ${size}`;
  const t5 = size / 2;
  const t6 = size / 2;
  let t7;
  if ($[2] !== className) {
    t7 = cn("stroke-gray-300", className);
    $[2] = className;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== circumference || $[5] !== effectiveCircleStrokeWidth || $[6] !== radius || $[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
    t8 = <circle r={radius} cx={t5} cy={t6} fill="transparent" strokeWidth={effectiveCircleStrokeWidth} strokeDasharray={circumference} strokeDashoffset={0} className={t7} />;
    $[4] = circumference;
    $[5] = effectiveCircleStrokeWidth;
    $[6] = radius;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = size / 2;
  const t10 = size / 2;
  const t11 = isComplete || isTerminal ? effectiveProgressStrokeWidth * 100 : effectiveProgressStrokeWidth;
  const t12 = isComplete ? "stroke-green-600" : error ? "stroke-red-600" : warning ? "stroke-amber-500" : "stroke-n-violet-platform";
  let t13;
  if ($[11] !== progressClassName || $[12] !== t12) {
    t13 = cn(t12, progressClassName);
    $[11] = progressClassName;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      transition: "stroke-dashoffset 0.5s ease, stroke-width 0.3s ease-in-out, stroke 0.2s ease 300ms"
    };
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== circumference || $[16] !== radius || $[17] !== shape || $[18] !== strokeDashoffset || $[19] !== t10 || $[20] !== t11 || $[21] !== t13 || $[22] !== t9) {
    t15 = <circle r={radius} cx={t9} cy={t10} fill="transparent" strokeWidth={t11} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap={shape} className={t13} style={t14} />;
    $[15] = circumference;
    $[16] = radius;
    $[17] = shape;
    $[18] = strokeDashoffset;
    $[19] = t10;
    $[20] = t11;
    $[21] = t13;
    $[22] = t9;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== size || $[25] !== t15 || $[26] !== t4 || $[27] !== t8) {
    t16 = <svg width={size} height={size} viewBox={t4} className="-rotate-90 transform rounded-full">{t8}{t15}</svg>;
    $[24] = size;
    $[25] = t15;
    $[26] = t4;
    $[27] = t8;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== isComplete || $[30] !== labelClassName || $[31] !== size) {
    t17 = isComplete && <div className={cn("absolute inset-0 flex items-center justify-center text-[0.625rem]", labelClassName)}><AnimatedCheckmark size={size} /></div>;
    $[29] = isComplete;
    $[30] = labelClassName;
    $[31] = size;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== error || $[34] !== labelClassName || $[35] !== size) {
    t18 = error && <div className={cn("absolute inset-0 flex items-center justify-center text-[0.625rem]", labelClassName)}><AnimatedDanger size={size} /></div>;
    $[33] = error;
    $[34] = labelClassName;
    $[35] = size;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== error || $[38] !== labelClassName || $[39] !== size || $[40] !== warning) {
    t19 = warning && !error && <div className={cn("absolute inset-0 flex items-center justify-center text-[0.625rem]", labelClassName)}><AnimatedDanger size={size} /></div>;
    $[37] = error;
    $[38] = labelClassName;
    $[39] = size;
    $[40] = warning;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t16 || $[43] !== t17 || $[44] !== t18 || $[45] !== t19 || $[46] !== t3) {
    t20 = <div className="relative" style={t3}>{t16}{t17}{t18}{t19}</div>;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
    $[45] = t19;
    $[46] = t3;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  return t20;
};
const AnimatedCheckmark = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    delay: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const delay = t2 === undefined ? 0 : t2;
  const t3 = `0 0 ${size} ${size}`;
  const t4 = `#Rectangle_1 {
                animation: 200ms linear ${delay}ms 1 normal forwards running Rectangle_1;
            }
            @keyframes Rectangle_1 {
                0% {
                    height: 0px;
                }
                40% {
                    height: 5px;
                }
                100% {
                    height: 5px;
                }
            }
            #Rectangle_2 {
                animation: 300ms linear ${delay + 200}ms 1 normal forwards Rectangle_2;
            }
            @keyframes Rectangle_2 {
                0% {
                    height: 2px;
                    opacity: 0;
                }
                40% {
                    height: 2px;
                    opacity: 1;
                }
                100% {
                    height: 11px;
                    opacity: 1;
                }
            }`;
  let t5;
  if ($[0] !== t4) {
    t5 = <style>{t4}</style>;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <g id="Frame"><rect id="Rectangle_1" x="4" y="10.2" width="2" height="0" rx="1" transform="rotate(-45 4 10.2)" fill="#D9D9D9" /><rect id="Rectangle_2" x="8.5" y="14" width="2" height="0" rx="1" transform="rotate(-135 8.5 14)" fill="#D9D9D9" /></g>;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== size || $[4] !== t3 || $[5] !== t5) {
    t7 = <svg width={size} height={size} viewBox={t3} fill="none" xmlns="http://www.w3.org/2000/svg">{t5}{t6}</svg>;
    $[3] = size;
    $[4] = t3;
    $[5] = t5;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
};
export const AnimatedDanger = t0 => {
  const $ = _c(10);
  const {
    size: t1,
    delay: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const delay = t2 === undefined ? 0 : t2;
  const scale = 24 / size;
  const t3 = `scale(${scale})`;
  let t4;
  if ($[0] !== t3) {
    t4 = {
      transform: t3,
      transformOrigin: "right bottom"
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `0 0 ${size} ${size}`;
  const t6 = `#Line {
            animation: 300ms linear ${delay}ms 1 normal forwards running Line;
            transform-origin: 50% 0%;
        }
        @keyframes Line {
            0% {
                height: 0px;
            }
            100% {
                height: 6px;
            }
        }
        #Dot {
            animation: 200ms linear ${delay + 300}ms 1 normal forwards Dot;
        }
        @keyframes Dot {
            0% {
                transform: scale(0);
                transform-origin: 50% 0%;
            }
            100% {
                transform: scale(1);
                transform-origin: 50% 0%;
            }
        }`;
  let t7;
  if ($[2] !== t6) {
    t7 = <style>{t6}</style>;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <g id="Frame"><circle id="Dot" cx="11.5" cy="15.5" r="1" transform="scale(0)" fill="white" /><rect id="Line" x="10.5" y="6.5" width="2" height="0" rx="1" fill="white" /></g>;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== size || $[6] !== t4 || $[7] !== t5 || $[8] !== t7) {
    t9 = <svg style={t4} width={size} height={size} viewBox={t5} fill="none" xmlns="http://www.w3.org/2000/svg">{t7}{t8}</svg>;
    $[5] = size;
    $[6] = t4;
    $[7] = t5;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};